import { initializeApp } from 'firebase/app';
import { getAuth, onAuthStateChanged } from 'firebase/auth';
import { getFirestore, collection, query, where, getDocs, doc, getDoc, updateDoc, addDoc, serverTimestamp, writeBatch, collectionGroup, orderBy, limit } from 'firebase/firestore';
import { getFunctions } from 'firebase/functions';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
    apiKey: 'AIzaSyCOo80uTBbCaOzHRoWHPsICVpyYnBukqXM',
    authDomain: 'sellox-prod.firebaseapp.com',
    databaseURL: 'https://sellox-prod.firebaseio.com',
    projectId: 'sellox-prod',
    storageBucket: 'sellox-prod.appspot.com',
    messagingSenderId: '255551438908',
    appId: '1:255551438908:web:e74eaedbb26fb6aa470339',
    measurementId: 'G-VBY7JMEBYZ'
}
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const functions = getFunctions(app);
export const storage = getStorage(app);

// Expose to window for scraper bridge
if (typeof window !== 'undefined') {
    (window as any).firebaseAuth = auth;
    (window as any).firebaseDb = db;
    (window as any).firebaseFirestore = {
        collection, query, where, getDocs, doc, getDoc, updateDoc, addDoc, serverTimestamp, writeBatch, collectionGroup, orderBy, limit
    };
    (window as any).firebaseAuthMethods = {
        onAuthStateChanged
    };
}

export default app;
